@if (softwareWarning() === true) {
  <mat-icon
    class="warning"
    aria-label="software update available"
    matTooltip="Software update available"
    >sync_problem</mat-icon
  >
} @else if (softwareWarning() === false) {
  <mat-icon
    class="positive"
    aria-label="software up to date"
    matTooltip="Software up to date"
    >sync</mat-icon
  >
} @else {
  <mat-icon
    class="neutral"
    aria-label="software status unknown"
    matTooltip="Software status unavailable"
    >sync_disabled</mat-icon
  >
}
